/**
 * SnsAccountDialog — "SNS 계정으로 가입되어 있어요" 안내.
 * 아이디 찾기·비밀번호 찾기가 각각 `position: fixed` 스크림을 손으로 그리고 있었다.
 * ui-core `Modal`(§15.6)로 합쳐 포커스 트랩·Esc·포커스 복원을 함께 얻는다.
 *
 * 버튼 구성은 화면마다 다르다 — 아이디 찾기는 더 진행할 것이 없어 [SNS 로그인] 하나,
 * 비밀번호 찾기는 재설정을 이어갈 수 있어 [계속 진행]이 붙는다. `onContinue` 유무로 갈린다.
 */
import { Button, Modal } from '@indipia/ui-core';

const SNS_NAME: Record<string, string> = { KAKAO: '카카오', NAVER: '네이버', GOOGLE: '구글', APPLE: '애플' };

interface SnsAccountDialogProps {
  open: boolean;
  types: string[];
  onClose: () => void;
  onGoLogin: () => void;
  /** 주면 [계속 진행] 버튼이 함께 노출된다 */
  onContinue?: () => void;
}

export function SnsAccountDialog({ open, types, onClose, onGoLogin, onContinue }: SnsAccountDialogProps) {
  return (
    <Modal open={open} onClose={onClose} title="SNS 계정으로 가입되어 있어요.">
      <p className="text-body-sm text-text-secondary" style={{ wordBreak: 'keep-all' }}>
        {types.map((t) => SNS_NAME[t] ?? t).join(', ')}(으)로 가입한 계정입니다.
        <br />SNS 로그인을 이용해 주세요.
      </p>

      <div className="mt-06 flex gap-sm">
        {onContinue && (
          <Button variant="secondary" size="lg" className="flex-1" onClick={onContinue}>
            계속 진행
          </Button>
        )}
        <Button variant="primary" size="lg" className="flex-1" onClick={onGoLogin}>
          SNS 로그인{onContinue ? '' : '으로 이동'}
        </Button>
      </div>
    </Modal>
  );
}
